(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-mjr-catalog-sales]').forEach((section) => {
      if (section.dataset.mjrCatalogBound === 'true') return;
      section.dataset.mjrCatalogBound = 'true';

      const reveals = section.querySelectorAll('[data-mjr-catalog-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveals.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      reveals.forEach((item) => observer.observe(item));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
